/** @format */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ServiceBootstrapComponent } from './service-bootstrap.component';

@NgModule({
    declarations: [ServiceBootstrapComponent],
    imports: [CommonModule],
    exports: [ServiceBootstrapComponent],
})
export class HybridBootstrapModule {}
